import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Switch, Route, useHistory, useParams, Link } from 'react-router-dom';
import BrowserOnly from 'components/consumer/BrowserOnly';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPProductDetailsModal from 'components/consumer/PDP/PDPProductDetailsModal';
import { PDP_CTA, trackPDPCtaClicked } from 'data-hooks/useEvents/pdpInteractionEvents';
const PDPDetailsAndProductCareLink = () => {
  const $ = _c(12);
  const history = useHistory();
  const {
    data: t0
  } = useProductAttributes();
  const {
    assemblyDetailsPDF
  } = t0;
  const {
    category,
    slug
  } = useParams();
  const pathToDetailsModal = `/${category}/${slug}/details`;
  const label = assemblyDetailsPDF ? "Details, product care & assembly instructions +" : "Details and product care +";
  let t1;
  if ($[0] !== label || $[1] !== pathToDetailsModal) {
    t1 = () => trackPDPCtaClicked({
      cta: PDP_CTA.PRODUCT_CARE_DETAILS,
      text: label,
      targetUrl: pathToDetailsModal
    });
    $[0] = label;
    $[1] = pathToDetailsModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label || $[4] !== pathToDetailsModal || $[5] !== t1) {
    t2 = <Link to={pathToDetailsModal} className="text-base font-bold text-brand cursor-pointer hover:underline" onClick={t1}>{label}</Link>;
    $[3] = label;
    $[4] = pathToDetailsModal;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== history) {
    t3 = <Switch><Route path="/:category/:slug/details"><BrowserOnly><PDPProductDetailsModal isOpen={true} onClose={() => {
            history.goBack();
          }} /></BrowserOnly></Route></Switch>;
    $[7] = history;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="PDPDetailsAndProductCareLink">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default PDPDetailsAndProductCareLink;